import { EventEmitter } from "events";

import { NAVIGATE_FROM_HOST_WITH_URL_EVENT_ID } from "./HostStore.listeners";

class HostStoreEventEmitter {
    eventEmitter: any;
    subscriptions: any[] = [];

    constructor() {
        this.eventEmitter = new EventEmitter();
        this.subscriptions = [];
    }

    getEventEmitter = () => {
        return this.eventEmitter;
    };

    navigateFromHostHandler = (url: string) => {
        this.eventEmitter.emit(NAVIGATE_FROM_HOST_WITH_URL_EVENT_ID, url);
        // this.subscriptions.push({ eventId: NAVIGATE_FROM_HOST_WITH_URL_EVENT_ID, callback: url });
    };

    removeNavigateFromHostHandler = () => {
        this.findAndRemoveEventListenerByEventId(NAVIGATE_FROM_HOST_WITH_URL_EVENT_ID);
    };

    findAndRemoveEventListenerByEventId = (eventId: string) => {
        const foundListener = this.subscriptions.find((subscription) => subscription.eventId === eventId);
        if (!foundListener) {
            return;
        }
        this.eventEmitter.removeListener(foundListener.eventId, foundListener.callback);
        this.subscriptions = this.subscriptions.filter((subscription) => subscription.eventId !== eventId);
    };

    registerEventSubscription = (eventId: string, callback: any) => {
        this.subscriptions.push({ eventId, callback });
    };

    removeAllEventListeners = () => {
        for (let subscriptionIndex = 0; subscriptionIndex < this.subscriptions.length; subscriptionIndex++) {
            const foundListener = this.subscriptions[subscriptionIndex];
            if (!foundListener) {
                return;
            }
            this.eventEmitter.removeListener(foundListener.eventId, foundListener.callback);
        }
        this.subscriptions = [];
    };
}

export default new HostStoreEventEmitter();
